/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// redux utils
import { createSlice } from '@reduxjs/toolkit';
// thunks
import { 
    fetchProfileConfig, updateProfileConfig
} from '../thunks/profile'
import { sortArrays } from 'utils/sortArrays';
import { GENDER_OPTIONS } from 'utils/consts';

/* ========== ~~~~~~~~~~ PROFILE CONFIG SLICE : REDUCER ~~~~~~~~~~ ========== */

const initialState = {
    status: 'initial',
    isUpdating: false,
    profileConfig: {
      uuid: null,
      useGender: false,
      genderOptions: [],
      useAbout: false,
      aboutSectionOptions: []
    }
};


export const profileConfigSlice = createSlice({
    name: 'moderation',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
      builder
        // fetch profile config
        .addCase(fetchProfileConfig.pending, (state, action) => {
            state.status = 'pending'
        })
        .addCase(fetchProfileConfig.fulfilled, (state, action) => {
            state.status = 'fulfilled'
            state.profileConfig = action.payload
            if(action.payload.useAbout === undefined) {
                state.profileConfig.useAbout = false
                state.profileConfig.aboutSectionOptions = []
            }
            state.profileConfig.genderOptions = sortArrays([...GENDER_OPTIONS], [...action.payload.genderOptions])
        })
        .addCase(fetchProfileConfig.rejected, (state, action) => {
            state.status = 'rejected'
        })   

        // update profile config
        .addCase(updateProfileConfig.pending, (state, action) => {
            state.isUpdating = true
        })
        .addCase(updateProfileConfig.fulfilled, (state, action) => {
            if(action.payload) state.profileConfig = action.payload
            state.isUpdating = false
        })
        .addCase(updateProfileConfig.rejected, (state, action) => {
            state.isUpdating = false
        })      

    }
});

export default profileConfigSlice.reducer;
